import { Button, TablePagination, TextField } from "@mui/material";
import { commonComponentIcons } from "helpers/images";
import React, { useEffect, useRef, useState } from "react";
import Table from "react-bootstrap/Table";
import styled from "styled-components";
import FilterBy from "../FilterBy";
import InputBox from "../InputBox";
import { NormalCheckbox } from "../NormalCheckbox";
import Pagination from "../Pagination";
import classes from "./styles.module.scss";
const NormalTable = (props) => {
  const {
    isLoading = false,
    handleCheck,
    title,
    headers,
    children,
    withTBody,
    setwidth = false,
    headerBackground,
    pageCount = 1,
    activePage = 1,
    isSearch = false,
    isPagination = false,
    setactivePage,
    setsearch,
    search,
    boxShadow = false,
    isFilter = false,
    filterDropdownOptions,
    userManagementTablePaddingTop,
    onChangeFilter,
    clearFilter,
    searchPlaceHolder = "Search By Name",
    setCheckedAll,
    customePaddingForActionCheckbox,
    headerClassName,
    page,
    rowsPerPage,
    handleChangeRowsPerPage,
    isPaginationNew,
    handleGo,
    goToPage,
    setGoToPage,
  } = props

  const [datum, setDatum] = useState(headers)

  const CustomTablePagination = styled.div`
    .MuiTablePagination-root p {
      margin: 0px;
    }
  `

  const headerRef = useRef(null)
  const [headerOffset, setHeaderOffset] = useState(0)

  useEffect(() => {
    setDatum(headers)
  }, [headers])

  useEffect(() => {
    if (headerRef.current) {
      const offsetTop = headerRef.current.offsetTop
      setHeaderOffset(offsetTop)
    }
  }, [headerRef])

  useEffect(() => {
    if (headerOffset !== 0) {
      window.scrollTo({ top: headerOffset, behavior: "smooth" })
    }
  }, [headerOffset])

  const selectAllCheckBox = (e) => {
    if (e.currentTarget.checked) {
      setCheckedAll(true)
    } else {
      setCheckedAll(false)
    }
  }

  // Handle "Go to page" input change

  return (
    <>
      <div className={`${boxShadow && classes.contentListBox}`}>
        <div className="bg-white px-2 pt-3 px-3">
          <div
            className={`d-flex justify-content-between 
            ${userManagementTablePaddingTop ? `p-3` : ""} ${
              customePaddingForActionCheckbox ? `p-4` : ""
            } align-items-center tableData  ${classes.silverRate}`}
          >
            <div className="">
              <div className="fs-20 text-black fw-700 ">{title}</div>
            </div>
            <div className={`${classes.tableserchBoxContainer} d-flex `}>
              {isFilter && (
                <FilterBy
                  label={"Filter by status"}
                  filterDropdownOptions={filterDropdownOptions}
                  onChangeFilter={onChangeFilter}
                  clearFilter={clearFilter}
                />
              )}
              {isSearch && (
                <div className="">
                  <InputBox.SearchBox
                    // name="search"
                    placeholder={searchPlaceHolder}
                    onChange={(e) => setsearch(e.target.value)}
                    value={search}
                    className={`${classes.tableserchBox}`}
                  />
                </div>
              )}
            </div>
          </div>

          <Table
            className={`${classes.normalTable} `}
            responsive
            ref={headerRef}
          >
            <thead className="tableHeader">
              <tr>
                {datum?.map((header, index) => {
                  return (
                    <th
                      className={setwidth ? classes.minwidth : undefined}
                      style={{ backgroundColor: headerBackground }}
                      key={index}
                    >
                      <div
                        className={` d-flex align-items-center justify-content-center ${headerClassName} ${classes.filterIcons}`}
                      >
                        {header.checkbox ? (
                          <NormalCheckbox
                            onChange={(e) => selectAllCheckBox(e)}
                          />
                        ) : (
                          <>
                            <div>{header.label}</div>{" "}
                            {header.icon && (
                              <img
                                src={commonComponentIcons.sort}
                                className="img-fluid cursor-pointer ps-2"
                                alt="sort"
                                onClick={handleCheck}
                              />
                            )}
                          </>
                        )}

                      </div>
                    </th>
                  )
                })}
              </tr>
            </thead>
            {withTBody ? (
              children
            ) : (
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={10}>
                      <div class="spinner-border text-warning" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  children
                )}{" "}
              </tbody>
            )}
          </Table>
        </div>
      </div>

      {isPagination && pageCount > 1 ? (
        <Pagination
          pageCount={pageCount}
          setactivePage={setactivePage}
          activePage={activePage}
        />
      ) : (
        ""
      )}
      {isPaginationNew && pageCount > 10 ? (
        <div>
          <div className="d-flex align-items-center flex-row-reverse">
            <CustomTablePagination>
              {/* Table Pagination */}
              <TablePagination
                component="div"
                count={pageCount}
                page={page}
                onPageChange={setactivePage}
                showLastButton
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                showFirstButton
                sx={{
                  ".MuiTablePagination-select": {
                    border: "1px solid rgb(152, 38, 32)", // Add border
                    borderRadius: "4px", // Optional: rounded corners
                    padding: "8px", // Optional: padding inside
                  },
                  ".MuiTablePagination-actions .MuiIconButton-root": {
                    height: "35px",
                    width: "35px",
                    borderRadius: "50%",
                    "&:hover": {
                      backgroundColor: "rgb(152, 38, 32)", // Add hover background color
                    },
                  },
                  ".MuiTablePagination-actions .MuiIconButton-root.Mui-disabled":
                    {
                      backgroundColor: "transparent", // Optional: ensure disabled buttons have no background
                    },
                }}
              />
            </CustomTablePagination>
            {/* Go to Page Input */}
            <div className="d-flex gap-2 justify-content-end ">
              <div className="w-25">
                <TextField
                  variant="outlined"
                  size="small"
                  label="Page"
                  value={goToPage === null ? "" : goToPage}
                  onChange={(e) => {
                    const value = e.target.value
                    if (/^\d*$/.test(value)) {
                      setGoToPage(value) // Update state only if the value is numeric
                    }
                  }}
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 10,
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "rgb(152, 38, 32)", // Set the default border color
                      },
                      "&:hover fieldset": {
                        borderColor: "rgb(152, 38, 32)", // Set the border color on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "rgb(152, 38, 32)",
                        color: "rgb(152, 38, 32)",
                      },
                    },
                    "& .MuiInputBase-root": {
                      height: "40px", // Adjust height if needed
                    },
                  }}
                />
              </div>

              <Button
                variant="contained"
                color="primary"
                sx={{
                  padding: "0px 0px",
                  backgroundColor: "rgb(152, 38, 32)", // Custom background color
                  color: "white", // Custom text color
                  "&:hover": {
                    backgroundColor: "rgb(152, 38, 32)", // Background color on hover
                  },
                  height: "40px",
                }}
                onClick={(e) => {handleGo()}}
              >
                Go
              </Button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  )
}

export default NormalTable;